import {
  DataTypeEventConfig,
  EventTypeBase,
  EventTypeConfig,
  HierarchyLevelEventConfig,
  SessionSubTypeConfig,
  SessionTypeConfig,
  SportConfig
} from './config'

export const EMPTY_EVENT_TYPE_BASE: EventTypeBase = {
  name: {
    en: ''
  },
  value: 'FreeJson',
  abbr: '',
  metrics: {},
  outcomes: {},
  features: {},
  tags: {}
}

export const EMPTY_SPORT_CONFIG: SportConfig = {
  ...EMPTY_EVENT_TYPE_BASE,
  playerSummaryMetrics: {},
  events: {
    Session: {
      ...EMPTY_EVENT_TYPE_BASE,
      sessionTypes: {}
    }
  }
}

export const EMPTY_SESSION_TYPE_CONFIG: SessionTypeConfig = {
  ...EMPTY_EVENT_TYPE_BASE,
  sessionSubTypes: {}
}

export const EMPTY_SESSION_SUB_TYPE_CONFIG: SessionSubTypeConfig = {
  ...EMPTY_EVENT_TYPE_BASE,
  hierarchyLevels: {}
}

export const EMPTY_HIERARCHY_LEVEL_EVENT_CONFIG: HierarchyLevelEventConfig = {
  ...EMPTY_EVENT_TYPE_BASE,
  dataTypes: {}
}

export const EMPTY_DATA_TYPE_EVENT_CONFIG: DataTypeEventConfig = {
  ...EMPTY_EVENT_TYPE_BASE,
  value: 'FreeJson' as const,
  types: {}
}

export const EMPTY_EVENT_TYPE_CONFIG: EventTypeConfig = {
  ...EMPTY_EVENT_TYPE_BASE,
  subTypes: {}
}
